import { Component } from '@angular/core';
import { IonicPage, NavController, NavParams } from 'ionic-angular';
import { UserProvider } from '../../providers/user';
import { TeamappProvider } from '../../providers/teamapp';

import {ChatSinglePage} from "../chat-single/chat-single";
import {ChatNewPage} from "../chat-new/chat-new";
import {ChatGroupPage} from "../chat-group/chat-group";
import {ChatGroupAddPage} from "../chat-group-add/chat-group-add";

/**
 * Generated class for the ChatPage page.
 *
 * See https://ionicframework.com/docs/components/#navigation for more info on
 * Ionic pages and navigation.
 */

@IonicPage()
@Component({
  selector: 'page-chat',
  templateUrl: 'chat.html',
})
export class ChatPage {
  title: string = 'Chat';
  conversations: any = [];
  conversationsCount: number = -1;
  conversationsUnreadCount: number = -1;
  chatExecuteTimer: any;
  searchChat: string = '';
  older: boolean = false;
  constructor(public navCtrl: NavController, public navParams: NavParams, public userProvider: UserProvider, public teamappProvider: TeamappProvider) {
    //this.getChatList();

  }

  onOlderChange() {
    this.getChatList(true, true);
    console.log("change to "+this.older);
  }
  ionViewDidLoad() {
    console.log('ionViewDidLoad ChactPage');
  }

  ionViewDidEnter() {
    this.listenToChatList();
    this.getChatList(true, true);
  }

  ionViewWillLeave() {
    console.log('CLOSE TIMER')
    this.stopListenToChat();
  }

  createNewGroupChat() {
    this.navCtrl.push(ChatGroupAddPage);
  }

  openNewChat() {
    this.navCtrl.push(ChatNewPage);
  }

  openChat(params: any) {
    if(params.type == 'user_to_user') {
      console.log("tats params");
      console.log(params);
      this.navCtrl.push(ChatSinglePage, {params: params});
    } else if(params.type == 'user_to_group') {
      this.navCtrl.push(ChatGroupPage, {params: params});
    }
  }

  loadOlderButton() {
    this.older = true;
    this.onOlderChange();
  }

  getChatList(loading: boolean = false, force = false) {
    this.teamappProvider.http_request('action=get_chat_list&older='+this.older, 'chat_v2', false, loading).then(data => {
      let dataTmp: any = data
      if(dataTmp.messageCountTotal != this.conversationsCount || dataTmp.messageCountTotalUnread != this.conversationsUnreadCount || force == true) {

        this.conversationsCount = dataTmp.messageCountTotal;
        this.conversationsUnreadCount = dataTmp.messageCountTotalUnread;

        this.conversations = dataTmp.messageData;
        console.log("reading chat data");
        console.log(data);
      }
    });
  }

  listenToChatList() {
    this.chatExecuteTimer = setInterval( () => {
      this.getChatList(false);
    }, 2000);
  }

  stopListenToChat() {
    clearInterval(this.chatExecuteTimer);
  }

}



// WEBPACK FOOTER //
// ./src/pages/chat/chat.ts